export { l as CoralogixEventType, j as CoralogixLogSeverity, i as CoralogixRum, O as OtelNetworkAttrs, P as PerformanceTypes, k as SessionRecordingEventType, U as UrlBasedLabelProvider, m as UrlType } from './index.esm2.js';
import 'tslib';
import '@opentelemetry/sdk-trace-base';
import '@opentelemetry/sdk-trace-web';
import '@opentelemetry/instrumentation';
import 'error-stack-parser';
import '@opentelemetry/instrumentation-fetch';
import '@opentelemetry/instrumentation-xml-http-request';
import 'web-vitals/attribution';
import '@opentelemetry/api';
import '@opentelemetry/propagator-b3';
import '@opentelemetry/propagator-aws-xray';
